class CartChangeVariant extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

      let loading = document.querySelector('.custom__loading');
      loading.classList.add('loading');

      const formData = {
        updates: {
          [`${this.dataset.variantSelected}`]: 0,
        },
      };
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then(response => {
          const formDataR = {
            'items': [{
              'id': this.dataset.variantValue,
              'quantity': 1,
            }],
          };
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formDataR),
          })
            .then(response => {
              // return response.json();
              setTimeout(() => {
                cartItems.updateQuantityVariant(1, 1);
              }, 1000);

            })
            .catch((error) => {
            });
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });

  }
}

customElements.define('cart-change-variant', CartChangeVariant);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (cartItems.classList.contains('cart-drawer__last_added')) {
        const itemQuantity = event.currentTarget?.dataset.quantity;
        let quantity = 0;
        if (itemQuantity) quantity = itemQuantity - 1;
        cartItems.updateQuantity(this.dataset.index, quantity, 'lastAdded');
      } else {
        const itemVariantId = event.currentTarget?.dataset.variantId;
        const lastAddedVariantId = document.getElementById('lastAddedWrapper')?.querySelector('cart-remove-button')?.dataset.variantId;
        let name = '';
        if (itemVariantId === lastAddedVariantId) name = 'lastAdded';
        cartItems.updateQuantity(this.dataset.index, 0, name);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.attachQuantityInputListeners();

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  attachQuantityInputListeners() {
    this.quantityInputs = this.querySelectorAll('.quantity__input');

    this.quantityInputs.forEach(input => {
      input.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.keyCode === 13) {
          event.preventDefault();
        }
      });
    });
  }

  onChange(event) {
    if (!event.target.dataset.index) return
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    // Don't update the quantity if the item is extra item
    let hasExtraItem = false;
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => {
        const linePosition = data.items.findIndex(item => window.cartExtraItemsIds.includes(item.variant_id));
        if (linePosition + 1 === line) hasExtraItem = true;
      });

    if (hasExtraItem && quantity > 0) return;

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (response.status === 422) {
          this.disableLoading();
          throw new Error(`${line} quantity is not available.`); 
        }
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        // Hide Featured collection and Recommended section and place Footer to the bottom of page if no items in cart
        const featuredCollection = document.querySelector('.cart-featured-collection');
        const recommendedSection = document.querySelector('.section-recommended');
        const footer = document.querySelector('footer.footer');
        if (parsedState.item_count === 0) {
          if (featuredCollection) featuredCollection.classList.add('hidden');
          if (recommendedSection) recommendedSection.classList.add('hidden');
          if (footer) footer.classList.add('cart-no-items');
        }

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        // Remove extra items if no other items in cart
        let hasOnlyExtraItems = true;
        parsedState.items.forEach(item => {
          if (!window.cartExtraItemsIds.includes(item.variant_id)) {
            hasOnlyExtraItems = false;
          }
        })
        if (hasOnlyExtraItems) {
          parsedState.items.forEach((item, index) => {
            this.updateQuantity(index + 1, 0, '');
          })
        }

        // Hide 'LAST ADDED' element in cart drawer if no item in element 
        const lastAddedWrapper = document.getElementById('lastAddedWrapper');
        if (lastAddedWrapper && name === 'lastAdded') {
          sessionStorage.setItem('hasLastAdded', 'false');
        }
        if (sessionStorage.getItem('hasLastAdded') === 'false') {
          lastAddedWrapper.classList.add('hidden');
        }

        this.disableLoading();

        this.attachQuantityInputListeners();
      }).catch(() => {
        const inputField = this.querySelector(`#Quantity-${line}`);
        const availableQuantity = inputField?.dataset.availableQuantity;
        const lineItemError = document.getElementById(`Line-item-error-${line}`);

        if (inputField) inputField.value = availableQuantity;

        // Update the quantity to the available quantity
        if (lineItemError && availableQuantity) {
          lineItemError
            .querySelector('.cart-item__error-text')
            .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            availableQuantity
          );

          fetch(`${routes.cart_update_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              line: line,
              quantity: availableQuantity
            })
          })
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(data => {
            // Update cart count excluding the extra items
            const counterBubble = document.querySelector('.cart-count-bubble .cart-count__update');
            let itemCount = data.item_count;
            data.items.forEach(item => {
              if (window.cartExtraItemsIds[item.variant_id]) {
                itemCount = itemCount - 1
              }
            })
            counterBubble.innerText = itemCount;
          })
          .catch(error => console.error('Error:', error));
        }

        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
    });
  }

  updateQuantityVariant(line, quantity, name) {
    // this.enableLoading(line);
    let loading = document.querySelector('.custom__loading');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        // this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        // this.disableLoading();
        loading.classList.remove('loading');

        this.attachQuantityInputListeners();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        // this.disableLoading();
        loading.classList.remove('loading');
    });
  }

  updateLiveRegions(itemCount) {
    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300));
    }
  });
}

class CartChangeExtraItem extends HTMLElement {
  constructor() {
    super()
    const cartItems = document.getElementById('cart-items')
    const variantId = this.dataset.variantId
    let routeCartUrl = ''
    let quantity = 0

    this.addEventListener('click', () => {
      this.style.pointerEvents = 'none'

      const isInCart = this.classList.contains('in-cart')
      
      isInCart ? 
      (
        // If item is in cart, remove it
        this.classList.remove('in-cart'),
        routeCartUrl = routes.cart_change_url,
        quantity = 0
      )
      :
      (
        // If item is not in cart, add it
        this.classList.add('in-cart'),
        routeCartUrl = routes.cart_add_url,
        quantity = 1
      )

      const body = JSON.stringify({
        id: variantId,
        quantity: quantity,
        sections: cartItems.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      })

      fetch(`${routeCartUrl}`, { ...fetchConfig(), ...{ body } })
        .then(response => response.json())
        .then(parsedState => {
          cartItems.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
            elementToReplace.innerHTML =
              cartItems.getSectionInnerHTML(parsedState.sections[section.section], section.selector)
          }))

          cartItems.updateLiveRegions(parsedState.item_count)

          this.style.pointerEvents = ''
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    })
  }
}

customElements.define('cart-change-extra-item', CartChangeExtraItem);
